import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { ProfileThumbService } from './../../../shared/services/profile-thumb.service';
import { IProfileThumb } from './../../../_models/account/IProfile';
import { SettingService } from '../../../shared/services/setting.service';
import { ISetting } from '../../../_models/cms/ISetting';
import { MediaFileService } from '../../../shared/services/media-file.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile-thumb-form',
  templateUrl: './profile-thumb-form.component.html'
})
export class ProfileThumbFormComponent implements OnInit {

  loading: boolean;
  skeleton: boolean = true;
  title: string = 'Add Photo & Sign';
  profileThumb: IProfileThumb;
  profileThumbForm: FormGroup;
  id;

  pic: string = "/assets/img/extra/img_avatar.png";
  sin: string = "/assets/img/extra/img_sign.png";

  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;

  setting: ISetting;

  constructor(private router: Router,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private mediaFileService: MediaFileService,
    private service: ProfileThumbService,
    private transferRequestService: TransferRequestService,
    private settingService: SettingService) {
  }

  async ngOnInit() {
    this.createProfileThumbForm();

    this.setting = await this.settingService.getSetting();

    if (this.setting && !this.setting.isProfile) {
      this.toastrService.warning("profile module closed!");
      this.router.navigate(['/employee']);
    }
    this.getTransferRequest();
  }

  getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
        else {
          
        }
      }
    },
    (error) => console.log('HTTP Error', error),
    () => {
      this.getProfileThumb();
      this.skeleton = false;
    });
  }

  getProfileThumb() {
    this.service.logged().subscribe((response: IProfileThumb) => {
      if (response) {
        this.profileThumb = response;
        this.id = this.profileThumb.profileId;
        this.title = 'Edit Photo & Sign';

        this.pic = response.photo.mediaUrl;
        this.sin = response.sign.mediaUrl;

        this.setValueProfileThumbForm();
      }
    });
  }

  createProfileThumbForm() {
    this.profileThumbForm = this.fb.group({
      profileId: [''],
      photoId: ['', Validators.required],
      signId: ['', Validators.required]
    });
  }

  setValueProfileThumbForm() {
    this.profileThumbForm.patchValue({
      profileId: this.profileThumb.profileId,
      photoId: this.profileThumb.photoId,
      signId: this.profileThumb.signId
    });
  }

  save() {
    if (this.profileThumbForm.valid) {
      this.loading = true;
      this.profileThumb = Object.assign({}, this.profileThumbForm.value);
      if (this.id) {
        this.service.update(this.id, this.profileThumb).subscribe((response: IProfileThumb) => {
          if (response) {
            this.toastrService.success('photo & sign updated successful');
            this.router.navigate(['/employee/service-book/present-place']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.profileThumb).subscribe((response: IProfileThumb) => {
          if (response) {
            this.toastrService.success('photo & sign added successful');
            this.router.navigate(['/employee/service-book/present-place']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }


  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(thumb, field: string) {
    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          if (field == 'photo') {
            this.profileThumbForm.patchValue({
              photoId: event.body.id
            });
            this.pic = event.body.mediaUrl;
            this.toastrService.success('photo uploaded successfully.');
          }
          else if (field == 'sign') {
            this.profileThumbForm.patchValue({
              signId: event.body.id
            });
            this.sin = event.body.mediaUrl;
            this.toastrService.success('sign uploaded successfully.');
          }

        }
      },
      (error) => {
        console.log(error);
        thumb.value = null;
      },
      () => console.log("complete"));
  }

}
